import { render, staticRenderFns } from "./SettingsSummary.vue?vue&type=template&id=37815921&"
import script from "./SettingsSummary.vue?vue&type=script&lang=js&"
export * from "./SettingsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports